import React from "react";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import "./UseTermsPage.css";

const UseTermsPage = () => {
    return (
        <div className="container-page">
            <PageTitle title="Termos de Uso" />
            <div className="padding-default">
                <p>
                    O site <strong>Telepedido Santillana Educação</strong> é um serviço interativo oferecido por meio de página eletrônica na internet que possibilita realizar pagamentos de pedidos por meio de cartão de crédito.
                </p>
                <p>
                    O acesso representa a aceitação expressa e irrestrita dos termos de uso abaixo descritos. Se você não concorda com os termos, por favor, não acesse nem utilize este site.
                </p>

                <h3 className="margin-top-default margin-bottom">Uso do Site</h3>
                <p>
                    O visitante poderá usar este site apenas para finalidades lícitas. Este espaço não poderá ser utilizado para publicar, enviar, distribuir ou divulgar conteúdos ou informações de propriedade exclusiva pertencentes a outras pessoas ou empresas, bem como marcas registradas ou informações protegidas por direitos autorais, sem a expressa autorização do detentor desses direitos.
                </p>
                <p>
                    Ainda, o visitante não poderá usar o site para obter ou divulgar as informações aqui contidas, inclusive endereços na Internet, sobre os usuários do site.
                </p>

                <h3 className="margin-top-default margin-bottom">Garantia e Responsabilidade</h3>
                <p>
                    A <strong>Santillana Educação</strong> empenha-se em manter a qualidade, atualidade e autenticidade das informações do site, mas seus criadores e colaboradores não se responsabilizam por eventuais falhas nos serviços ou inexatidão das informações oferecidas.
                </p>
                <p>
                    O usuário não deve ter como pressuposto que tais serviços e informações são isentos de erros ou serão adequados aos seus objetivos particulares.
                </p>

                <h3 className="margin-top-default margin-bottom">Acesso e Alterações</h3>
                <p>
                    O acesso ao site é gratuito. O visitante compromete-se a não compartilhar em hipótese alguma o acesso com terceiros.
                </p>
                <p>
                    A <strong>Santillana Educação</strong> poderá, a seu exclusivo critério e em qualquer tempo, modificar ou desativar o site, bem como limitar, cancelar ou suspender seu uso ou o acesso.
                </p>
                <p>
                    Estes Termos de Uso poderão ser alterados a qualquer tempo. Visite regularmente esta página e consulte os Termos então vigentes.
                </p>
            </div>
        </div>
    );
};

export default UseTermsPage;
